// removed by extract-text-webpack-plugin
module.exports = {"SendFromSection":"SendFromSection---2w0sp","DeliveryOptionEnter":"DeliveryOptionEnter---33PYZ","DeliveryOptionLeave":"DeliveryOptionLeave---3mONb","EditableArea":"EditableArea---3TYWF","lifeIn":"lifeIn---2w6ZK","InputWrapper":"InputWrapper---2RLyx","CtaTypeMenuOption":"CtaTypeMenuOption---2OHE3","CtaType__upgradeRequired":"CtaType__upgradeRequired---2GuIt","CtaTypeUpgradeLink":"CtaTypeUpgradeLink---375TN"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/CampaignWizards/MessageUsers/Compose/EditableArea/style.styl
// module id = mHc7
// module chunks = 89